import { ResultObj, allFetch, } from "../Domain";

export interface CarCreateParams {
    vin_no: string;
    license_plate: string;
    licensed_date: string;
    customer_id: string;
    driver_name: string;
    driver_phone: string;
    driver_email: string;
    driver_city: string;
    driver_area: string;
    driver_address: string;
    ctf_id: string;
    year: string;
    mileage: string;
    [key: string]: string;
}

/**
 * @description 車籍新建
 */
export const CarCreate = async (
    obj: CarCreateParams
): Promise<ResultObj> => {
    return await allFetch('Car/CarCreate', obj);
};

export interface CarCreateFromExcelParams {
    vin_no: string;
    license_plate: string;
    driver_name: string;
    driver_phone: string;
}

/**
 * @description 從 Excel 新增車輛
 */
export const CarCreateFromExcel = async (
    obj: CarCreateFromExcelParams
): Promise<ResultObj> => {
    return await allFetch('Car/CarCreateFromExcel', obj);
};

export interface CarSearchParams {
    vin_no: string;
    license_plate: string;
    customer_id: string;
    car_id: string;
    year: string;
    ct_id: string;
    ctf_id: string;
    page: number;
    num_per_page: number;
    [key: string]: string | number;
}

export interface CarSearchResItem {
    car_id: string;
    vin_no: string;
    license_plate: string;
    licensed_date: string;
    customer_id: string;
    driver_name: string;
    driver_phone: string;
    driver_email: string;
    driver_city: string;
    driver_area: string;
    driver_address: string;
    cre_time: string;
    year: number;
    mileage: number;
    ctf_id: number;
    format_code: string;
    format_name: string;
    ct_id: number;
    car_type: string;
}

/**
 * @description 車籍查詢
 */
export const CarSearch = async (
    obj: CarSearchParams
): Promise<ResultObj<CarSearchResItem[]>> => {
    return await allFetch('Car/CarSearch', obj);
};

export interface CarUpdateParams {
    car_id: string;
    vin_no: string;
    license_plate: string;
    licensed_date: string;
    customer_id: string;
    driver_name: string;
    driver_phone: string;
    driver_email: string;
    driver_city: string;
    driver_area: string;
    driver_address: string;
    ctf_id: string;
    year: string;
    mileage: string;
}

/**
 * @description 修改車輛
 */
export const CarUpdate = async (
    obj: CarUpdateParams
): Promise<ResultObj> => {
    return await allFetch('Car/CarUpdate', obj);
};

export interface CarUpdateFromExcelParams {
    car_id: string;
    vin_no?: string;
    license_plate?: string;
    driver_name?: string;
    driver_phone?: string;
}

/**
 * @description 從 Excel 修改車輛
 */
export const CarUpdateFromExcel = async (
    obj: CarUpdateFromExcelParams
): Promise<ResultObj> => {
    return await allFetch('Car/CarUpdateFromExcel', obj);
};

export interface CarUpdateCustomerParams {
    car_id: string;
    customer_id: string;
}

/**
 * @description 修改車主
 */
export const CarUpdateCustomer = async (
    obj: CarUpdateCustomerParams
): Promise<ResultObj> => {
    return await allFetch('Car/CarUpdateCustomer', obj);
};

export interface CarDetailParams {
    car_id: string;
}

export interface CarDetailResItem {
    car_id: string;
    vin_no: string;
    license_plate: string;
    licensed_date: string;
    customer_id: string;
    driver_name: string;
    driver_phone: string;
    driver_email: string;
    driver_city: string;
    driver_area: string;
    driver_address: string;
    cre_time: string;
    year: string;
    mileage: string;
    ctf_id: string;
    format_code: string;
    format_name: string;
    ct_id: string;
    car_type: string;
    [key: string]: string;
}

/**
 * @description 車籍詳情查詢
 */
export const CarDetail = async (
    obj: CarDetailParams
): Promise<ResultObj<CarDetailResItem[]>> => {
    return await allFetch('Car/CarDetail', obj);
};

export interface CarLicenseRecordLogSearchParams {
    license_plate: string;
    position_id: string;
    date_start: string;
    date_end: string;
    page: number;
    num_per_page: number;
}

export interface CarLicenseRecordLogSearchResItem {
    cam_ip: string
    cre_time: string
    license_plate: string
    position_id: string
    position_name: string
    customer_name: string
}

/**
 * @description 車牌辨識歷史紀錄查詢
 */
export const CarLicenseRecordLogSearch = async (
    obj: CarLicenseRecordLogSearchParams
): Promise<ResultObj> => {
    return await allFetch('Car/CarLicenseRecordLogSearch', obj);
};
